import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/coastal-dusk.css';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative" style={{ background: '#1a1a1a' }}>
      <div className="landing-orb cool focus-shift" style={{ '--orb-opacity': '0.3', top: '-5%', left: '-5%', width: '45vw', height: '45vw', maxWidth: '500px', maxHeight: '500px' }} />
      <div className="landing-orb neutral" style={{ '--orb-opacity': '0.2', top: '55%', right: '-5%', width: '42vw', height: '42vw', maxWidth: '450px', maxHeight: '450px', animationDelay: '-4s' }} />

      <div className="max-w-2xl mx-auto px-6 sm:px-10 py-20 relative z-10">
        <button
          onClick={() => navigate(-1)}
          className="landing-ghost-link mb-10 block"
          style={{ fontSize: '0.82rem' }}
          data-testid="back-btn"
        >
          &larr; Back
        </button>

        <h1 className="text-display mb-2" style={{ fontSize: 'clamp(1.4rem, 4vw, 1.8rem)' }}>
          Privacy Policy &amp; Disclosure
        </h1>
        <p className="landing-step-body" style={{ color: 'var(--text-secondary)', fontSize: '0.82rem', marginBottom: '48px' }}>
          Effective Date: April 11, 2026 &middot; Last Updated: April 11, 2026<br />
          Operator: EnQUIPs LLC &middot; Contact: info@clarityjournalbyenquips.com
        </p>

        <p className="landing-step-body" style={{ marginBottom: '32px' }}>
          By accessing or using Clarity Soundtrack, you agree to the terms of this Disclosure and Privacy Policy.
        </p>

        {/* DISCLOSURE */}
        <h2 className="landing-step-heading" style={{ fontSize: '1.1rem', marginBottom: '16px' }}>Disclosure</h2>
        <p className="landing-step-body">
          Clarity Soundtrack offers guided reflective prompts and AI-generated insights to support personal 
          clarity. These insights are suggestions — not directives.
        </p>
        <p className="landing-step-body">Clarity Soundtrack does not provide:</p>
        <ul className="landing-step-body" style={{ paddingLeft: '1.5rem', listStyleType: 'disc' }}>
          <li style={{ marginBottom: '6px' }}>Financial, investment, or tax advice</li>
          <li style={{ marginBottom: '6px' }}>Medical advice or mental health treatment</li>
          <li style={{ marginBottom: '6px' }}>Legal or professional recommendations of any kind</li>
        </ul>
        <p className="landing-step-body">
          All insights are AI-generated. No human reviews your journal entries or your insights at any point. 
          Your experience is personal and self-directed. We cannot guarantee any specific emotional, financial, 
          or personal outcome. How you choose to interpret or act on your reflections remains entirely your 
          responsibility.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '32px', marginBottom: '12px' }}>
          Refund Policy
        </h3>
        <p className="landing-step-body">
          This journaling experience is delivered and made accessible instantly. Because the value cannot be 
          returned or revoked, all sales are final and refunds are not applicable.
        </p>

        <div className="landing-tide-line" style={{ margin: '48px 0' }} />

        {/* PRIVACY POLICY */}
        <h2 className="landing-step-heading" style={{ fontSize: '1.1rem', marginBottom: '16px' }}>Privacy Policy</h2>
        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginBottom: '12px' }}>
          How Your Data Is Handled
        </h3>
        <p className="landing-step-body">
          We follow a data-minimization philosophy. Here is the complete picture of how your information is treated:
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Journal Entries
        </h3>
        <p className="landing-step-body">
          Your reflections are used solely to generate your AI-powered insights, then permanently deleted. 
          They are never stored long-term, never reviewed by a human, and cannot be retrieved or restored after deletion.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Your Insights
        </h3>
        <p className="landing-step-body">
          The insights generated from your session belong only to you. You may download or revisit them at any 
          time. If you prefer not to retain your insights — for example, if you choose not to create a login — 
          simply let us know after your session ends. Insights will be deleted within 24 hours and cannot be 
          restored after that point.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '12px' }}>
          What We Collect
        </h3>
        <div style={{ overflowX: 'auto', marginBottom: '24px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'var(--font-body)', fontSize: '0.88rem' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(163,163,163,0.15)' }}>
                <th style={{ textAlign: 'left', padding: '10px 12px', color: 'var(--text-primary)', fontWeight: 400 }}>Type</th>
                <th style={{ textAlign: 'left', padding: '10px 12px', color: 'var(--text-primary)', fontWeight: 400 }}>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid rgba(163,163,163,0.08)' }}>
                <td style={{ padding: '10px 12px', color: 'var(--text-secondary)', verticalAlign: 'top' }}>Information you provide</td>
                <td style={{ padding: '10px 12px', color: 'var(--text-secondary)' }}>Journal entries (temporary), email address, payment information (processed by third-party providers — we do not store card details)</td>
              </tr>
              <tr>
                <td style={{ padding: '10px 12px', color: 'var(--text-secondary)', verticalAlign: 'top' }}>Automatically collected</td>
                <td style={{ padding: '10px 12px', color: 'var(--text-secondary)' }}>Device type, browser type, general usage data, IP address (for security and fraud prevention only)</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginBottom: '8px' }}>
          How We Use Your Information
        </h3>
        <p className="landing-step-body">
          We use your information to generate AI-powered insights, process payments, communicate with you 
          about your purchase, any updates from enquips, and maintain platform security and performance. 
          We do not sell, rent, or trade your personal information.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Sharing Your Information
        </h3>
        <p className="landing-step-body">
          We share information only with trusted third-party providers who help us operate the platform — such 
          as payment processors, hosting providers, and analytics tools. We do not share your data with advertisers.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Data Retention
        </h3>
        <p className="landing-step-body">
          Journal entries are deleted immediately after insights are generated. Purchase and account 
          information is retained as required for business, legal, or tax purposes. Analytics data is retained 
          in aggregated, non-identifiable form only.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Your Rights
        </h3>
        <p className="landing-step-body">
          You may request access to or deletion of your personal information at any time by contacting 
          info@clarityjournalbyenquips.com. We honor these requests whenever legally and operationally possible.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Children's Privacy
        </h3>
        <p className="landing-step-body">
          Clarity Soundtrack is intended for adults 18 and older. We do not knowingly collect information from 
          individuals under 18. If we learn a minor has used the Services, we will delete their information promptly.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Third-Party Links
        </h3>
        <p className="landing-step-body">
          The Services may reference external resources for convenience. We are not responsible for the privacy 
          practices of third-party websites.
        </p>

        <h3 style={{ fontFamily: 'var(--font-body)', fontWeight: 400, fontSize: '0.95rem', color: 'var(--text-primary)', marginTop: '24px', marginBottom: '8px' }}>
          Legal Basis for Processing
        </h3>
        <p className="landing-step-body">
          We process your information based on your consent, our need to provide the services you request, 
          and our legitimate interest in maintaining platform security and performance.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
